var _rect, _path, _path2, _circle, _circle2, _circle3, _ellipse, _ellipse2, _ellipse3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeo4J(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Neo4j logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 6,
    ry: 6,
    fill: "#0F1722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 24 C21 20, 27 20, 30 24",
    fill: "none",
    stroke: "#7ED957",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24 C15 27, 21 31, 24 30",
    fill: "none",
    stroke: "#7ED957",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 24,
    r: 5.2,
    fill: "#00A36C",
    stroke: "#FFFFFF",
    strokeOpacity: 0.06,
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 6.2,
    fill: "#00A36C",
    stroke: "#FFFFFF",
    strokeOpacity: 0.06,
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 24,
    r: 4.2,
    fill: "#00A36C",
    stroke: "#FFFFFF",
    strokeOpacity: 0.06,
    strokeWidth: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.2,
    cy: 16.2,
    rx: 3.2,
    ry: 1.4,
    fill: "rgba(255,255,255,0.08)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.2,
    cy: 22.2,
    rx: 2.4,
    ry: 1,
    fill: "rgba(255,255,255,0.06)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2,
    cy: 22.2,
    rx: 1.8,
    ry: 0.8,
    fill: "rgba(255,255,255,0.06)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,34)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 6.8,
    fill: "#E6F8EE"
  }, "neo"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 0,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 6.8,
    fill: "#7ED957",
    textAnchor: "start"
  }, "4j"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeo4J);
export default __webpack_public_path__ + "static/media/neo4j.3a921bf95f56ea8f84f47dae167d2baf.svg";
export { ForwardRef as ReactComponent };